import sanitizeHtml from "sanitize-html";

export function extractVariables(message) {
    const regex = /\{(.*?)\}/g;
    let match;
    let variables = {};

    while ((match = regex.exec(message)) !== null) {
        // 초기값을 빈 문자열로 설정
        variables[match[1]] = '';
    }

    return variables;
}

export function extractUrls(message) {
    const regex = /\[(URL분석.)\]/g;
    let match;
    let urls = {};

    while ((match = regex.exec(message)) !== null) {
        // 초기값을 빈 문자열로 설정
        urls[match[1]] = 'https://';
    }

    return urls;
}

export function renderMessage(message, variableMap, urlMap) {
    message = message || '';

    if (urlMap) {
        message = message.replace(/\[(URL분석.)\]/g, (_, url) =>   `<mark>${urlMap[url] || `[${url}]`}</mark>`);
    }

    return message.replace(/\{(.*?)\}/g, (_, variable) =>   `<mark>${variableMap[variable] || `{${variable}}`}</mark>`)
}

export function removeMarkTags(inputString) {
    return inputString.replace(/<\/?mark>/g, '');
}

export function convertNewlineToBr(inputString) {
    let sanitized = sanitizeHtml(inputString, {
        allowedTags: ["mark", "br", "span"],
        allowedAttributes: {
            'span': ["class"]
        }
    });

    return sanitized.replace(/\n/g, '<br/>');
}
export function convertBrToNewline(inputString) {
    return inputString.replace(/<br\/>/g, '\n');
}

export function pureNumber(str) {
    return ('' + str).replace(/\D/g, '');
}

export function removeSpecialLetter(str) {
    return str.replace(/[\{\}\[\]\/?.,;:|\)*~`!^\-_+<>@\#$%&\\\=\(\'\"]/gi, '');
}

export function formatNumber(number) {
    if (! number) return 0;
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export function formatPhone(phoneNumber) {
    // 정규 표현식을 사용하여 숫자를 그룹화
    const cleaned = ('' + phoneNumber).replace(/\D/g, '');

    // 9~11자리 전화번호 형식
    const match11 = cleaned.match(/^(\d{2,3})(\d{3,4})(\d{4})$/);

    // 8자리 전화번호 형식
    const match8 = cleaned.match(/^(\d{4})(\d{4})$/);

    if (match11) {
        return `${match11[1]}-${match11[2]}-${match11[3]}`;
    } else if (match8) {
        return `${match8[1]}-${match8[2]}`;
    }

    return '';
}


export function convertDateToLocaltime(dateString) {
    const date = new Date(dateString);

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // 월은 0부터 시작하므로 +1 필요
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()+2).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');

    return `${year}-${month}-${day}T${hours}:${minutes}`;
}

export function toDate(localDateTimeString) {
    const [datePart, timePart] = localDateTimeString.split('T');
    const [year, month, day] = datePart.split('-');
    const [hours, minutes] = timePart.split(':');

    return new Date(year, month - 1, day, hours - 2, minutes);
}
